module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-25.e5081b45.jpg";